/**
 * Web twin of the app's HeaderWash (components/ui/HeaderWash.tsx): brand teal at
 * 15% fading to transparent over the top 200px. Parent must be `relative`.
 */
export function HeaderWash() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 top-0 h-[200px] z-0"
      style={{ background: 'linear-gradient(180deg, rgba(13, 148, 136, 0.15) 0%, rgba(13, 148, 136, 0) 100%)' }}
    />
  )
}
